"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableList = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var clamp_1 = tslib_1.__importDefault(require("lodash-es/clamp"));
var lodash_move_1 = tslib_1.__importDefault(require("lodash-move"));
var react_use_gesture_1 = require("react-use-gesture");
var react_spring_1 = require("react-spring");
var styles_1 = require("@material-ui/styles");
var index_1 = require("../index");
var useStyles = styles_1.makeStyles({
    draggableMai: {
        margin: 0,
        padding: 0,
        overflow: "hidden",
        userSelect: "none",
    },
    draggableInner: {
        position: "relative",
        width: "100%",
        "& > div": {
            position: "absolute",
            width: "100%",
            overflow: "visible",
            pointerEvents: "auto",
            transformOrigin: "50% 50% 0px",
            borderRadius: 5,
            textTransform: "uppercase",
            cursor: "grab",
            "&:active": { cursor: "grabbing" },
        },
    },
});
var fn = function (order, down, originalIndex, curIndex, y) { return function (index) {
    return down && index === originalIndex
        ? {
            y: curIndex * 28 + y,
            scale: 1.0,
            zIndex: "1",
            shadow: 15,
            immediate: function (n) { return n === "y" || n === "zIndex"; },
        }
        : {
            y: order.indexOf(index) * 28,
            scale: 1,
            zIndex: "0",
            shadow: 1,
            immediate: false,
        };
}; };
function DraggableList(props) {
    var items = props.items, onClick = props.onClick;
    var order = react_1.useRef(items.map(function (_, index) { return index; }));
    var _a = tslib_1.__read(react_spring_1.useSprings(items.length, fn(order.current)), 2), springs = _a[0], setSprings = _a[1];
    var bind = react_use_gesture_1.useGesture(function (_a) {
        var _b = tslib_1.__read(_a.args, 1), originalIndex = _b[0], down = _a.down, _c = tslib_1.__read(_a.delta, 2), y = _c[1];
        var curIndex = order.current.indexOf(originalIndex);
        var curRow = clamp_1.default(Math.round((curIndex * 28 + y) / 28), 0, items.length - 1);
        var newOrder = lodash_move_1.default(order.current, curIndex, curRow);
        setSprings(fn(newOrder, down, originalIndex, curIndex, y));
        if (!down)
            order.current = newOrder;
    });
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.draggableMai, style: { height: items.length * 28 } },
        react_1.default.createElement("div", { className: classes.draggableInner, style: { height: items.length * 10 } }, springs.map(function (_a, index) {
            var zIndex = _a.zIndex, y = _a.y, scale = _a.scale;
            return (react_1.default.createElement(react_spring_1.animated.div, tslib_1.__assign({}, bind(index), { key: index, style: {
                    zIndex: zIndex,
                    transform: react_spring_1.interpolate([y, scale], function (y, s) { return "translate3d(0," + y + "px,0) scale(" + s + ")"; }),
                }, children: react_1.default.createElement(index_1.DragView, { icon: items[index].icon, text: items[index].text, children: items[index].nodes, onClick: onClick }) })));
        }))));
}
exports.DraggableList = DraggableList;
//# sourceMappingURL=index.js.map